import { FEATURE_FLAGS } from '@/hooks/use-feature-flag/constants';
import type { FeatureFlag } from '@/hooks/use-feature-flag/types';
import {
  CUSTOM_FUNCTIONALITIES,
  type CustomFunctionality,
} from '@/lib/permissions/custom-functionalities';
import { Urls } from '@/lib/urls';
import {
  Building,
  DoorOpen,
  FileSpreadsheet,
  Receipt,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

/** Stable report keys, e.g. stored in saved report templates. */
export type DwReportKey =
  | 'objects'
  | 'rentroll'
  | 'vacancies'
  | 'errands'
  | 'invoices';

export interface DwReport {
  title: string;
  description: string;
  href: string;
  /** The role grant behind the report's collection. */
  grant: CustomFunctionality;
  /**
   * Optional per-report feature flag, required IN ADDITION to
   * `DATAWAREHOUSE`. Without it the report is hidden from Rapportmoduler
   * and its route redirects to not-found (see use-dw-access.ts and
   * app/reports-dw/layout.tsx).
   */
  flag?: FeatureFlag;
  icon: LucideIcon;
}

export const DW_REPORTS: DwReport[] = [
  {
    title: 'Objektslista',
    description: 'Sammanställning av objekt, bolag och fastigheter',
    href: Urls.dashboard.reportsDw.objects,
    grant: CUSTOM_FUNCTIONALITIES.DW_AGGR_SPACE,
    icon: Building,
  },
  {
    title: 'Rent roll',
    description: 'Hyresläge per objekt vid valt datum',
    href: Urls.dashboard.reportsDw.rentroll,
    grant: CUSTOM_FUNCTIONALITIES.DW_AGGR_SPACE,
    icon: FileSpreadsheet,
  },
  {
    title: 'Vakansrapport',
    description: 'Vakanta objekt vid valt datum',
    href: Urls.dashboard.reportsDw.vacancies,
    grant: CUSTOM_FUNCTIONALITIES.DW_AGGR_SPACE,
    icon: DoorOpen,
  },
  {
    title: 'Ärenden',
    description: 'Sammanställning av ärenden, kostnader och utförande',
    href: Urls.dashboard.reportsDw.errands,
    grant: CUSTOM_FUNCTIONALITIES.DW_AGGR_GENERAL_ERRAND,
    icon: Wrench,
  },
  {
    title: 'Avier & Fakturor',
    description: 'Avier och fakturor med status och belopp per period',
    href: Urls.dashboard.reportsDw.invoices,
    grant: CUSTOM_FUNCTIONALITIES.DW_AGGR_INVOICE,
    flag: FEATURE_FLAGS.DATAWAREHOUSE_INVOICES,
    icon: Receipt,
  },
];
